import React from 'react';
import PropTypes from 'prop-types';
import Workflow from 'components/workflow/Workflow';
import constants from 'utils/constants';

const NoRouteMatch = ({ history }) => (
  <Workflow
    title="404 Page Missing"
    onBack={() =>
      history.push({
        pathname: constants.WORKSPACES.DASHBOARD,
        state: {}
      })
    }
  >
    {/* TODO: Talk with UX to add recovery options / links */}
    <p />
  </Workflow>
);

NoRouteMatch.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default NoRouteMatch;
